import { getApiConfig } from "@/config/api";

// Removed unused import

/**
 * Utility function to construct image URLs that work in both Docker and local environments
 * Database stores only filename, frontend constructs full URL using API_URL (includes /api/v1)
 */
export function getImageUrl(imagePath: string): string {
  if (!imagePath) return '';
  const config = getApiConfig();

  // Extract filename from path (handles both filename-only and legacy full paths)
  const filename = imagePath.includes('/') ? imagePath.split('/').pop() : imagePath;

  // Construct URL using API_URL (which includes /api/v1)
  return `${config.API_URL}/files/public/items/${filename}`;
}

/**
 * Utility function to construct logo URLs using the public API endpoint
 * Database stores only filename (e.g., "xxx.png"), frontend constructs full URL
 */
export function getLogoUrl(logoPath: string | null | undefined): string {
  if (!logoPath) return '';
  if (logoPath.startsWith('http')) return logoPath;

  const config = getApiConfig();

  // Extract filename from path (handles both filename-only and legacy full paths)
  const filename = logoPath.includes('/') ? logoPath.split('/').pop() : logoPath;

  // Construct URL using API_URL (which includes /api/v1)
  return `${config.API_URL}/files/public/logos/${filename}`;
}

/**
 * Utility function to construct CFD media URLs (video or image for the customer display).
 * Uses the static /uploads path to support HTTP range requests needed for video playback.
 * Database stores only the filename; frontend constructs the full public URL.
 */
export function getCfdMediaUrl(path: string | null | undefined): string {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  const config = getApiConfig();
  const filename = path.includes('/') ? path.split('/').pop() : path;
  // Strip /api/v1 suffix to get server base URL for static file serving
  const serverBase = config.API_URL.replace(/\/api\/v1$/, '');
  return `${serverBase}/uploads/cfd/${filename}`;
}

/**
 * Utility function to construct expense receipt URLs that work in both Docker and local environments
 */
export function getReceiptUrl(expenseId: string): string {
  if (!expenseId) return '';
  const config = getApiConfig();

  // API_URL already includes /api/v1
  return `${config.API_URL}/expenses/${expenseId}/receipt`;
}
